import { render, staticRenderFns } from "./RemoteBanners.vue?vue&type=template&id=7ff44754&"
import script from "./RemoteBanners.vue?vue&type=script&lang=js&"
export * from "./RemoteBanners.vue?vue&type=script&lang=js&"
import style0 from "./RemoteBanners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports